import React, { useCallback, useId, useState } from "react";
import { MapPin, X } from "lucide-react";
import { publicDropPoints } from "../../utils/publicEventsApi";
import { EventOverlay } from "./eventOverlay";
import { useOverlayDismiss } from "./useOverlayDismiss";

const DropPointsDialog = ({ eventName, points, onClose }) => {
  const titleId = useId();
  useOverlayDismiss(onClose);

  return (
    <EventOverlay>
      <div className="smym-sheet-backdrop" onClick={onClose} role="presentation">
        <div
          className="smym-sheet"
          role="dialog"
          aria-modal="true"
          aria-labelledby={titleId}
          onClick={(event) => event.stopPropagation()}
        >
          <div className="smym-drawer__head">
            <div className="min-w-0">
              <p className="smym-drawer__eyebrow">SMYM Chennai</p>
              <h2 id={titleId} className="smym-drawer__title">
                Drop points
              </h2>
              {eventName ? <p className="smym-drawer__sub">{eventName}</p> : null}
            </div>
            <button
              type="button"
              onClick={onClose}
              className="smym-drawer__close"
              aria-label="Close"
            >
              <X size={20} aria-hidden />
            </button>
          </div>
          <div className="smym-sheet__body">
            <ul className="smym-drop-list">
              {points.map((point, index) => (
                <li key={`${point.address}-${index}`} className="smym-drop-list__item">
                  {point.label ? (
                    <p className="smym-drop-list__label">{point.label}</p>
                  ) : null}
                  <p className="smym-drop-list__address">{point.address}</p>
                  {point.mapsUrl ? (
                    <a
                      href={point.mapsUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="smym-drop-list__maps"
                    >
                      Open in Google Maps
                    </a>
                  ) : null}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </EventOverlay>
  );
};

/** Button that opens the event's drop-point list. Renders nothing when the list is empty. */
const DropPointsButton = ({ event, className }) => {
  const points = publicDropPoints(event);
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);
  if (points.length === 0) return null;

  return (
    <>
      <button
        type="button"
        className={className}
        aria-haspopup="dialog"
        onClick={() => setOpen(true)}
      >
        <MapPin className="h-4 w-4 shrink-0" aria-hidden />
        Drop points
      </button>
      {open ? (
        <DropPointsDialog
          eventName={event?.name || event?.title || ""}
          points={points}
          onClose={close}
        />
      ) : null}
    </>
  );
};

export default DropPointsButton;
